import { Observable } from 'rxjs';
import { USER_ID_KEY } from '../constants';
import { StorageService } from '../services';
import { ModulesService } from '../services/modules/modules.service';
import { CompanyModuleService } from '../services/company';
import { catchError, tap } from 'rxjs/operators';

export function moduleInitializer(
  modulesService: ModulesService,
  companyModuleService: CompanyModuleService
): () => Observable<unknown> {
  const isUserLogged = !!StorageService.GetItem(USER_ID_KEY);

  if (!isUserLogged) {
    const el = () =>
      new Observable((obs) => {
        obs.next(null);
        obs.complete();
      });

    return el;
  }

  return () =>
    modulesService.init().pipe(
      tap(() => {
        companyModuleService.init();
      }),
      catchError(() => {
        return new Observable((obs) => {
          obs.next(null);
          obs.complete();
        });
      })
    );
}
